module.exports = __webpack_public_path__ + "files/fe6a8eada8cb715b191663e2bbd00621.png";